interface Document {
  documentMode?: number;
}

export const isInternetExplorer = !!(<Document>window.document).documentMode;
